module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0023.jpg?v=12dfae76";